import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

const useGoBackToForm = () => {
  const navigate = useNavigate();

  const handleGoBackToForm = (location) => {
    navigate(location.pathname.replace("acknowledge", "form"), {
      state: location.state.data,
    });
  };

  return handleGoBackToForm;
};

export default useGoBackToForm;

/**
 * Is Responsible To Convert The React Hook Form JSON schema to the format that the Details Component needs
 * @param formSc
 * @returns
 */
export const transformer = (formSc) => {
  const formScTransformed = {};
  Object.keys(formSc).forEach((key) => {
    formScTransformed[key] = {
      ...formSc[key],
      name: key,
    };
  });
  return formScTransformed;
};

/** Casts each data type to the backend desired format
 *
 * e.g. Js Date Object to string
 */
export const handleAttrDataTypesOnApplicationSubmit = (data: any) => {
  if (data instanceof Date) return format(data, "dd/MM/yyyy");
  // if data is object
  if (typeof data === "object") {
    return data.id;
  }
  return data;
};

/**
 * Converts the JSON data to FormData
 * and adds the necessary fields for the backend
 * appTypeId,  * token,  * appId,
 *
 * @param data
 */
export const createFormDataOnApplicationSubmit = (data: any) => {
  const formData = new FormData();
  Object.keys(data.data).forEach((key) => {
    formData.append(
      key,
      handleAttrDataTypesOnApplicationSubmit(data.data[key]),
    );
  });

  formData.append("appTypeId", data.backendData.appTypeId);
  formData.append("token", data.backendData.token);
  formData.append("appId", "");
};

export function checkAFM(afm: string): boolean {
  if (!afm.match(/^\d{9}$/) || afm === "000000000") {
    return false;
  } else {
    let m = 1;
    let sum = 0;
    for (let i = 7; i >= 0; i--) {
      m *= 2;
      sum += parseInt(afm.charAt(i)) * m;
    }
    return (sum % 11) % 10 === parseInt(afm.charAt(8));
  }
}
